<priva-content-template hasContentPadding="all">
    <div class="wrapper">
        <div
            priva-card
            [hasFooter]="true"
            title="{{ 'DIALOG.RESET.TITLE' | translate }}"
            subtitle="{{ 'DIALOG.RESET.SUBTITLE' | translate }}"
            size="md"
        >
            <div data-footer>
                <priva-group>
                    <button priva-button importance="primary" theme="onwhite" (click)="reset()">
                        {{ 'GENERAL.ACTION.RESET' | translate }}
                    </button>
                    <button priva-button importance="secondary" theme="onwhite" (click)="cancel()">
                        {{ 'GENERAL.ACTION.CANCEL' | translate }}
                    </button>
                </priva-group>
            </div>
        </div>
    </div>
</priva-content-template>
